import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const COOKIE_KEY = 'd88-cookie-consent';

const CookieConsent: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setShow(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setShow(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_KEY, 'declined');
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="fixed left-0 right-0 z-[90] p-3 sm:p-6 bottom-[calc(4.25rem+env(safe-area-inset-bottom,0px))] lg:bottom-0"
        >
          <div className="max-w-2xl mx-auto bg-gray-950 border border-gray-800 rounded-2xl p-5 sm:p-6 shadow-2xl shadow-black/50">
            <div className="flex items-start gap-4">
              <div className="hidden sm:flex w-10 h-10 bg-gray-800 rounded-xl items-center justify-center flex-shrink-0">
                <Cookie size={20} className="text-gray-400" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-bold text-white mb-1">We use cookies</h3>
                <p className="text-xs text-gray-400 leading-relaxed">
                  District88 uses cookies to keep you logged in and improve your experience. 
                  Read our <Link to="/privacy" className="text-red-400 hover:underline">Privacy Policy</Link> for details.
                </p>
              </div>
              <button onClick={() => setShow(false)} className="p-1 text-gray-600 hover:text-gray-400 flex-shrink-0">
                <X size={16} />
              </button>
            </div>
            <div className="flex items-center gap-2 mt-4 sm:ml-14">
              <button
                onClick={accept}
                className="flex-1 sm:flex-none min-h-[48px] px-5 py-2.5 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-2xl transition-colors press-effect"
              >
                Accept All
              </button>
              <button
                onClick={decline}
                className="flex-1 sm:flex-none min-h-[48px] px-5 py-2.5 bg-gray-800 hover:bg-gray-700 text-gray-300 text-sm font-medium rounded-2xl transition-colors press-effect"
              >
                Essential Only
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
